import { IDevice } from '@pages/Assets/Inventory/types';
import { Input } from 'antd';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SessionContext from '@providers/Session/SessionContext';
import { IDeviceActionRequestPayload } from '../types';

interface INicknameChangeProps {
  handleDeviceActions: (item: IDeviceActionRequestPayload) => void;
  actionKey: number;
  devicesProps: IDevice[] | undefined;
  uploadedDevices: any;
}

function useNicknameChange({
  actionKey,
  devicesProps,
  uploadedDevices,
  handleDeviceActions,
}: INicknameChangeProps) {
  const [newNickname, setNewNickname] = useState('');
  const { t: translate } = useTranslation(['device-actions-modal']);
  const { theme } = useContext(SessionContext);

  const contentSteps =
    devicesProps && devicesProps?.length > 0
      ? [
          {
            title: translate('steps.nickname-change.name'),
            content: (
              <>
                <span style={{ color: theme?.colors?.text1 }}>
                  {translate('steps.nickname-change.description')}
                </span>
                <Input
                  value={newNickname}
                  onChange={event => {
                    setNewNickname(event.target.value);
                  }}
                  style={{ width: '100%', marginTop: 8 }}
                />
              </>
            ),
          },
        ]
      : [];

  const reinitState = () => {
    setNewNickname('');
  };
  const onSubmit = () => {
    const payload: IDeviceActionRequestPayload = {};
    payload.action = actionKey;

    payload.devices =
      devicesProps && devicesProps?.length > 0
        ? devicesProps?.map(({ msisdn, iccid }: IDevice) => {
            return { msisdn, iccid, processData: newNickname };
          })
        : uploadedDevices.map(({ nickname, ...device }: IDevice) => ({
            ...device,
            processData: nickname,
          }));

    return handleDeviceActions(payload);
  };

  const nicknameChangeData = {
    contentSteps,
    onSubmit,
    reinitState,
  };

  return { nicknameChangeData };
}

export default useNicknameChange;
